// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"LoginForm__loginForm__3HpEG","headline":"LoginForm__headline__2lysS","alertsMb":"LoginForm__alertsMb__kBPCR","submitButton":"LoginForm__submitButton__2Jjah","samlWrapper":"LoginForm__samlWrapper__2kOim","samlContent":"LoginForm__samlContent__2k0Zo","submitSamlButton":"LoginForm__submitSamlButton__19OmI","paragraph":"LoginForm__paragraph__3aJtM","redLink":"LoginForm__redLink__3x1ni"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.css
// module id = 1025
// module chunks = 0